import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

export default class i11v extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_i11rListsss: {i11r:[]},
  sdld_i11rDtlsss: {i11r:[]},
};

static op_loadSlcList = (pd={
  elm: null,
  i11r_fst: null,
}) => 
  (pd.elm == 'i110') ?
    super.op_loadSlcList({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = 
          (pd.i11r_fst) ?
            cf.c('i110', `i110b51k = (SELECT _key FROM t_i11r WHERE ${cf.c('i11r', `_fst = ${pd.i11r_fst}`)})`)
          : (pd.cnd) ?
            pd.cnd
          : cf.c(pd.elm, null);
        return _cnd;
      }),
      ld_sortss: [
        { fld: 'i110cx1i', dtn: 'asc', mode: 'nmb' }
      ],
    })
  : super.op_loadSlcList(pd);

static op_loadDtl = (pd={
}) => 
  (pd.elm == 'i11r') ?
    super.op_loadDtl({
      ...pd,
      dd_cldDefss: {
        i110: { // alias
          elm: 'i110',
          n_lmt: ic.gn_lmt,
          o_cnd: _dd_datss => {
            let _cnd = cf.c('i110', `i110b51k = ${_dd_datss.i11r.d_flds._key}`) // 要履歴対応
            return _cnd;
          },
          ld_sortss: [
            { fld: 'i110c11s', dtn: 'asc', mode: 'nmb'},
          ],
        },
      },
    })
  : super.op_loadDtl(pd);

$clp_loadLists = () => [ // 親を上書き
  i11v.op_loadList({
    elm: 'i11r',
  }),
];

$clp_loadDtls = () => [
  i11v.op_loadDtl({
    elm: 'i11r',
  }),
  i11v.op_loadVsnList({
    elm: 'i11r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_i11rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      i11r: {
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            i11rc11s: _dd_datss.i11r.d_flds.i11rc11s ?? '',
            i11rc31s: _dd_datss.i11r.d_flds.i11rc31s ?? '',
          };
          return _d;
        },
        dd_cldDefss: {
          i110: {
            b_setPageKey: false,
            od_insDats: _dd_datss => {
              let _d = {
                i110b51k: _dd_datss.i11r.d_flds._key ?? -1,
                i110c11s: _dd_datss.i110.d_flds.i110c11s ?? '',
                i110c31s: _dd_datss.i110.d_flds.i110c31s ?? '',
                i110i11t: _dd_datss.i110.d_flds.i110i11t ?? '',
                i110i12t: _dd_datss.i110.d_flds.i110i12t ?? '',
              };
              return _d;
            },
          },
        },
      },
    },

  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        pfx:
          (global.t?.state.sgc_pnlMode == 'list') ?
            '時間帯区分一覧・登録'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '時間帯区分詳細'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '時間帯区分詳細'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '時間帯区分新規登録'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              d_msgBfrs: {
                pfx: `【時間帯区分詳細の確認・変更】･･･IDを押すと詳細画面に移動し、変更もその画面で行えます。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i11rListsss',
                    dd_elmDefss: {
                      i11r: {
                        elm: 'i11r',
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,
                        d_insFlds: cf.e('i11r').d_insFlds,
                        d_btns: {
                          d_clds: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i11rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6) },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('i11rc31s', {
                            d_hdrs: { n_w: ic.s(6) },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                        ]),
                      },
                    },
                  }),
                ])

              ],
            },
            d_btms: {
/*
              d_news: {
                elm: 'i11r',
                state: 'sdld_i11rDtlsss',
                d_insFlds: {
                  ...cf.e('i11r').d_insFlds, 
                },
              },
*/
              l_clds: [
                ce.c(ce.Box, {
                  key: -2,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'iStg1',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx: '時間帯区分の新規登録',
                    b_rvs: false,
                    stlBtn: {
                      width: ic.s(12),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        elm: 'i11r',
                        state: 'sdld_i11rDtlsss',
                        d_insFlds: {
                          ...cf.e('i11r').d_insFlds, 
                        },
                        mode: 'sttNew',
                        b_clr: true, // 現行要素の初期化に必要
                      })
                    },
                  }),
                ])
              ],
            },
          }),

          ce.c(ce.Pnl, {
            key: -2,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'i11r',
                ld_iss: global.t?.state.sdld_i11rVsnListsss?.i11r,
                op_loadDtl: i11v.op_loadDtl,
              },
            },
            d_bdys: {
              d_stlCtas: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i11rDtlsss',
                    dd_elmDefss: {
                      i11r: {
                        elm: 'i11r',
                        b_ttl: true,
                        b_row: false,
                        b_rootHdr: false,
                        d_insFlds: cf.e('i11r').d_insFlds,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_cmns: {
                          n_cnt: 1,
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i11rc11s', {
                            d_hdrs: { n_w: ic.s(6) },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('i11rc31s', {
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                        ]),
                      },
                    },
                  }),
                ]),


                ce.c(ce.Box, {
                  key: -20,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i11rDtlsss',
                    dd_elmDefss: {
                      i11r: {
                        elm: 'i11r',
                        dd_cldDefss: {
                          i110: {
                            elm: 'i110',
                            b_row: true,
                            b_subHdr: true,
                            b_ttl: false,
                            d_btns: {
                              d_dlts: {
                                b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                              },
                            },
                            d_btns: {
                                d_btrs: {
                                  pfx: '時間帯を追加',
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                            },
                            d_insFlds: cf.e('i110').d_insFlds,
                            b_lyr: false,
                            dd_fldDefss: cf.myRN_getFldDefs([
                              cf.f('i110c11s', {
                                d_hdrs: { n_w: ic.s(7)  },
                                d_bdys: { n_w: ic.s(7) },
                              }),
                              cf.f('i110c31s', {
                                d_hdrs: { n_w: ic.s(7)  },
                                d_bdys: { n_w: ic.s(7) },
                              }),
                              cf.f('i110i11t', {
                                d_hdrs: { n_w: ic.s(7)  },
                                d_bdys: { n_w: ic.s(7) },
                              }),
                              cf.f('i110i12t', {
                                d_hdrs: { n_w: ic.s(7)  },
                                d_bdys: { n_w: ic.s(7) },
                              }),
                            ]),
                            d_stlSubBdyCtas: {
                              borderWidth: 0,
                              borderTopWidth: ic.gn_bdrWNrw,
                              borderBottomWidth: ic.gn_bdrWNrw,
                              borderColor: ic.o_getCcd('d'),
                            },
                          },
                        },
                      },
                    },
                    d_stlCtas: {
                      marginTop: ic.s(1.5),
                    },
                  }),
                ]),

              ],
            },
            d_btms: {
            },
          }),

        ],
      }
    })
  );
}

}
